import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { SysProductYvNameEnum } from 'src/shared/models/enums/sysProductEnums';

// Kommunikation är ingen produkt och har inget yvName; API:t har en egen nyckel för modulen.
const COMMUNICATION = 'communication';

// Adressens första del → modulens nyckel i API:t (yvName, samma som helppage-modules).
const modulesByPath: [string[], string][] = [
  [['/members', '/membersimport', '/othercontact', '/member'], SysProductYvNameEnum.MemberReg],
  [['/invoicing', '/einvoice', '/autogiro', '/swish', '/stripe'], SysProductYvNameEnum.Invoice],
  [['/groupmessage', '/sending', '/sendingorder', '/mailings'], COMMUNICATION],
  [['/events'], SysProductYvNameEnum.Event],
  [['/gifts'], SysProductYvNameEnum.Fundraiser],
  [['/statistics'], SysProductYvNameEnum.Statistics],
  [['/organization', '/mydistrict', '/myassociation', '/associations'], SysProductYvNameEnum.Organisation],
  [['/settings'], SysProductYvNameEnum.Settings],
  [['/files'], SysProductYvNameEnum.DocumentArchive],
  [['/support', '/admin'], SysProductYvNameEnum.Support],
];

/**
 * Modulen som sidan hör till, för hjälppanelens förslag. Bara hela delar av adressen räknas, så att /members inte
 * matchar /membersimport. Null för sidor utan modul (översikten, /me, /help).
 */
export const getHelpModuleForPath = (pathname: string): string | null => {
  const firstSegment = `/${pathname.split('/')[1] ?? ''}`.toLowerCase();
  const match = modulesByPath.find(([prefixes]) => prefixes.includes(firstSegment));

  return match ? match[1] : null;
};

/**
 * Sidor med den flytande hjälpknappen: sidor som hör till en modul, utom hjälpartiklarnas backoffice, där man skriver
 * artiklarna istället för att behöva hjälp med dem.
 */
export const showsHelpPanelButton = (pathname: string): boolean =>
  !!getHelpModuleForPath(pathname) && !pathname.toLowerCase().startsWith(RoutesEnum.HelpArticles);
